/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ChallengeCategoryDto } from './challenge-category-dto';

/**
 * 
 * @export
 * @interface CreateChallengeResponseDto
 */
export interface CreateChallengeResponseDto {
    /**
     * Unique identifier
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'deletedAt': string;
    /**
     * Title of the challenge
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'title': string;
    /**
     * Detailed description of the challenge
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'description': string;
    /**
     * Promotional description of the challenge for marketing purposes
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'promotionalDescription'?: string | null;
    /**
     * ID of the organizer
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'organizerId': string;
    /**
     * Whether the challenge is active
     * @type {boolean}
     * @memberof CreateChallengeResponseDto
     */
    'isActive': boolean;
    /**
     * Whether the challenge should be promoted/featured
     * @type {boolean}
     * @memberof CreateChallengeResponseDto
     */
    'shouldPromote': boolean;
    /**
     * URL of the cover image
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'coverImageUrl': string;
    /**
     * Array of other image URLs
     * @type {Array<string>}
     * @memberof CreateChallengeResponseDto
     */
    'otherImagesUrl': Array<string>;
    /**
     * Challenge start date and time in UTC
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'startsAt': string;
    /**
     * Challenge end date and time in UTC
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'endsAt': string;
    /**
     * Array of created challenge category options
     * @type {Array<ChallengeCategoryDto>}
     * @memberof CreateChallengeResponseDto
     */
    'challengeCategories': Array<ChallengeCategoryDto>;
    /**
     * Challenge status derived from dates and isActive flag
     * @type {string}
     * @memberof CreateChallengeResponseDto
     */
    'challengeStatus': CreateChallengeResponseDtoChallengeStatusEnum;
}

export const CreateChallengeResponseDtoChallengeStatusEnum = {
    NotStarted: 'not_started',
    Ongoing: 'ongoing',
    Ended: 'ended',
    Cancelled: 'cancelled'
} as const;

export type CreateChallengeResponseDtoChallengeStatusEnum = typeof CreateChallengeResponseDtoChallengeStatusEnum[keyof typeof CreateChallengeResponseDtoChallengeStatusEnum];


